import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUsers } from '../../actions/tenantStats';
import LineChart from '../charts/LineChart';
import { lineGraph } from '../charts/templates/lineGraph';
import Logger from '../../util/Logger';
import User from '../../models/User';
import { AnalyticsCardHeader } from './AnalyticsCardHeader';
import Tenant from '../../models/Tenant';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { handleError } from '../../util/Errors';
import DateTime from '../../models/DateTime';

class ActiveUsers extends Component {

  getYAxis = () => {
    return {
      title: {
        text: ''
      }
    };
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('Missing user in ActiveUsers component');
    }
  }

  fetchUsers = () => {
    const { user, fetchUsers, dateRange } = this.props;
    fetchUsers(Tenant.getId(User.getTenant(user)), dateRange.value);
  };

  componentDidMount () {
    this.fetchUsers();
  }

  componentDidUpdate (prevProps) {
    const { dateRange, usersError } = this.props;
    if (prevProps.dateRange.value !== dateRange.value) {
      this.fetchUsers();
    }

    handleError(usersError, prevProps.usersError);
  }

  formatSeriesData () {
    const { users } = this.props;
    if (!users) {
      return [];
    }
    let verifiedUsers = []; // values to be plotted along y-axis
    let guestUsers = []; // values to be plotted along y-axis
    let pointStart; // first date on x-axis
    let pointInterval; // time interval between data points
    users.forEach((timeInterval, index) => {
      let { startTime, endTime, verified_users, guest_users } = timeInterval;
      if (index === 0) {
        pointStart = endTime * 1000; // server returns seconds - Highcharts needs millis
        pointInterval = (endTime - startTime) * 1000; // server returns seconds - Highcharts needs millis
      }
      verifiedUsers.push(verified_users);
      guestUsers.push(guest_users);
    });
    return [
      {
        name: 'Verified Users',
        data: verifiedUsers,
        pointStart: pointStart,
        pointInterval: pointInterval
      },
      {
        name: 'Unverified Users',
        data: guestUsers,
        pointStart: pointStart,
        pointInterval: pointInterval
      }
    ];
  }

  formatTooltip = (tooltip) => {
    // Manually calculate percentages
    let sum = 0;
    const unformatted = [];
    for (let point of tooltip.points) {
      sum += point.y;
      unformatted.push({
        color: point.color,
        name: point.series.name,
        value: point.y
      });
    }

    const values = [];
    for (let unformattedEntry of unformatted) {
      switch (unformattedEntry.name) {
        case 'Verified Users':
          values[0] = { ...unformattedEntry, total: sum };
          break;
        case 'Unverified Users':
          values[1] = { ...unformattedEntry, total: sum };
          break;
        default:
          // Unexpected, continue anyway
          values.push({ ...unformattedEntry, total: sum });
      }
    }

    return (`
<div class="col">
    <div class="row no-gutters h-100 text-nowrap p-0 m-0" style="min-width: 12rem; margin-left: -1rem !important; margin-right: -1rem !important;">
      <div class="text-left fix-ie font-weight-bold mb-1">${DateTime.format(
      DateTime.unixSecondsToMoment(tooltip.x / 1000), 'ddd, MMM DD, YYYY')}</div>
    </div>
  ${ values.map(v => {
      let percentage = (v.total > 0) ? (v.value / v.total) * 100 : 0
      percentage = parseFloat(percentage.toFixed(2));
      return (`
  <div class="row no-gutters h-100 text-nowrap px-0 m-0" style="min-width: 10rem; margin-left: -1rem !important; margin-right: -1rem !important; margin-top 0.1rem; margin-bottom: 0.1rem;">
      <div style="background: ${v.color}; min-width: 0.5rem; max-width: 0.5rem; min-height: 0.5rem; max-height: 0.5rem;" class="rounded-circle m-auto"></div>
      <div class="text-left fix-ie pl-1">${v.name}</div>
      <div>${v.value}</div>
      <div>&nbsp;(${percentage}%)</div>
  </div>
`);
    }).join('')}
</div>
`.trim());
  };

  render () {
    const title = 'lineGraph';
    const { usersTotal, dateRange, usersLoading, usersError } = this.props;
    const formattedData = this.formatSeriesData();
    return (
      <div className="card analytics-card-height card-active-users">
        <AnalyticsCardHeader
          icon="people"
          count={ usersTotal ? usersTotal : '0' }
          title="ACTIVE USERS"
          dateRange={ dateRange } />
        <div className="row chart-container">
          <div className="col-12">
            { usersError
              ? (
                <ErrorAndRefresh
                  error="Failed to load Verified Users"
                  onRefresh={ this.fetchUsers }
                />
              )
              : usersLoading
                ? <LoadingAndPulse size={ 20 } color="#3D9AE2" whatIsLoading="chart" />
                : formattedData ? (
                    <LineChart
                      data={ formattedData }
                      chartType={ lineGraph }
                      yAxis={ this.getYAxis() }
                      xAxisTitle="Users"
                      tooltipFormatter={ this.formatTooltip }
                      chartId={ title } />)
                  : <div>No Verified Users</div>
            }
          </div>
        </div>
      </div>
    );
  }
}

ActiveUsers.propTypes = {};
ActiveUsers.defaultProps = {};

const mapStateToProps = state => {
  return {
    user: state.user.user,
    usersLoading: state.tenantStats.usersLoading,
    users: state.tenantStats.users,
    usersTotal: state.tenantStats.usersTotal,
    usersError: state.tenantStats.usersError
  };
};

export default connect(mapStateToProps, { fetchUsers })(ActiveUsers);
